export class LocalStorageUtil {

    public static setItem(key: string, value: string){
        if (typeof window !== 'undefined' && window.localStorage) {
            window.localStorage.setItem(key, value);
        } else {
            console.warn('localStorage is not available');
        }
    }

    public static getItem(key: string){
        if (typeof window !== 'undefined' && window.localStorage) {
            return window.localStorage.getItem(key);
        } else {
            console.warn('localStorage is not available');
        }
    }

    public static removeItem(key: string){
        if (typeof window !== 'undefined' && window.localStorage) {
            return window.localStorage.removeItem(key);
        } else {
            console.warn('localStorage is not available');
        }
    }

    public static clearStorage(){
        if (typeof window !== 'undefined' && window.localStorage) {
            return window.localStorage.clear();
        } else {
            console.warn('localStorage is not available');
        }
    }


}